import { render, staticRenderFns } from "./MoneyChart.vue?vue&type=template&id=2a850731"
import script from "./MoneyChart.vue?vue&type=script&lang=js"
export * from "./MoneyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports